import React, { ReactNode } from 'react';

import { Box } from 'components/Box';
import { PrimaryButtonLink } from 'components/Button';
import { Icon } from 'components/Icon';

type Props = {
  href: string;
  children: ReactNode | null | undefined;
};

export function StickyHeaderLinksBlockExternalLink({ href, children }: Props) {
  return (
    <PrimaryButtonLink href={href} target="_blank">
      {children}
      <Box transform="translateY(1px)" display="inline-block" ml="6px">
        <Icon
          initialColorName="todo-replace-me"
          name="arrow-up-right"
          size={12}
        />
      </Box>
    </PrimaryButtonLink>
  );
}
